var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdminCard',[_c('template',{slot:"title"},[_vm._v(" "+_vm._s(_vm.$t('forms.node.new'))+" ")]),_vm._v(" "+_vm._s(_vm.parentNode)+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }